import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DeveloperModeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"developer_mode"}/>
}
